import { TABLE_URL } from "../constants";
import { apiSlice } from "./apiSlice";

const tableApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTableById: builder.query({
      query: (data) => ({
        url: `${TABLE_URL}/getOutletTableById`,
        method: "POST",
        body: {
          outletId: data?.outletId,
          floor: data?.floor,
          tableNumber: data?.tableNumber,
        },
        headers: {
          Authorization: `Bearer ${data?.token}`,
        },
      }),
    }),
  }),
});
export const { useGetTableByIdQuery } = tableApiSlice;
